"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationStateProvider = exports.useNavigationState = void 0;
const unstated_next_1 = require("unstated-next");
const react_1 = require("react");
const useNavigationStateContainer = unstated_next_1.createContainer(() => {
    const [menuState, setMenuState] = react_1.useState('diagram');
    return { menuState, setMenuState };
});
exports.useNavigationState = useNavigationStateContainer.useContainer;
exports.NavigationStateProvider = useNavigationStateContainer.Provider;
